import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import Loading from '../general/Loading';
import SaleOrderInvoice from './SaleOrderInvoice';
import AddProduct from './AddProduct';
import AddParty from './AddParty';

const AddSale = ({ setResponse, userData }) => {
const [barcodeQuery, setBarcodeQuery] = useState('');
  const [parties, setParties] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productSearch, setProductSearch] = useState('');
  const [showDetail, setShowDetail] = useState(false);
const [savedBill, setSavedBill] = useState(null);
const [showAddItem, setShowAddItem] = useState(false);
const [showAddParty, setShowAddParty] = useState(false);
const now = new Date();
const date = now.toISOString().split('T')[0];
const lastAddedRowRef = useRef(null);


  const [formData, setFormData] = useState({
    partyId: '',
date: date,    paymentMethod: '',
    amountPaid: '',
    remark: '',
      extraCharges: 0,
    totalAmount: 0,
     grandTotal: 0,
    items: [
      // {
      //   itemId: '',
      //   name: '',
      //   mrp: 0,
      //   sell_price: 0,
      //   quantity: 1,
      //   price: 0,
      //   amount: 0,
      //     customPrice: false
      // }
    ]
  });
const inputRefs = useRef([]);


  const fetchProducts = async (input) => {
    if (!input || input.trim().length < 2) return;

    try {
      const res = await fetch(
        `https://api.siddhabhairabistore.com/get-admin-product?searchQuery=${input}`
      );

      if (res.ok) {
        const data = await res.json();
        setItems(data);
      }
    } catch (err) {
      console.error(err);
    }
  };


    const fetchParty = async (input) => {

    try {
      const res = await fetch(
        `https://api.siddhabhairabistore.com/get-customer`
      );

      if (res.ok) {
        const data = await res.json();
        // console.log(data);
        // const filtered = data.filter(p => p.stock && p.stock !== '0');
        setParties(data);
      }
    } catch (err) {
      console.error(err);
    }
  };


const fetchProductByBarcode = async (code) => {
if (!code) return;

  try {
    const res = await fetch(
      `https://api.siddhabhairabistore.com/get-admin-product?barcodeQuery=${code}`
    );

    if (res.ok) {
      const data = await res.json();

      if (data.length > 0) {
        addProductFromBarcode(data[0]); 
               setBarcodeQuery('');
        document.getElementById("barcodeInput")?.focus();
      } else {
        setResponse({ message: "Product not found", status: "error" });
    setTimeout(() => setResponse(''), 2000);
      }
    }
  } catch (err) {
    console.error(err);
  }
};

useEffect(() => {
  fetchParty();
}, [])

  // debounce search
useEffect(() => {
  const search = productSearch?.trim();

  if (!search || search.length < 3) {
    setItems([]);
    return;
  }

  const timer = setTimeout(() => {
    fetchProducts(productSearch);
  }, 500);

  return () => clearTimeout(timer);
}, [productSearch]);


const handleKey = (e, rowIndex, field) => {
  if (e.key === "Enter") {
    e.preventDefault();

    const isLastRow = rowIndex === formData.items.length - 1;

    if (isLastRow) {
      addRow(); // 👈 create new row
      setTimeout(() => {
        const nextRow = inputRefs.current[rowIndex + 1];
        nextRow?.mrp?.focus();
        nextRow?.mrp?.select?.();
      }, 0);
    } else {
      const nextRow = inputRefs.current[rowIndex + 1];
      nextRow?.mrp?.focus();
      nextRow?.mrp?.select?.();
    }
  }

  if (e.key === "Tab") {
    e.preventDefault();

    const fields = ["item", "mrp", "price", "qty", "amount"];
    const currentIndex = fields.indexOf(field);
    const nextField = fields[currentIndex + 1];

    if (nextField) {
      inputRefs.current[rowIndex]?.[nextField]?.focus();
    }
  }
};

useEffect(() => {
  const handleKeyDown = (e) => {
    const tag = document.activeElement?.tagName;

    const isTypingField =
      tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";

    if (e.key === "Shift" && isTypingField) {
      const barcodeInput = document.getElementById("barcodeInput");

      if (barcodeInput) {
        barcodeInput.focus();
        barcodeInput.select?.();
      }
    }
  };

  window.addEventListener("keydown", handleKeyDown);

  return () => window.removeEventListener("keydown", handleKeyDown);
}, []);

useEffect(() => {
  const subtotal = formData.items.reduce(
    (sum, i) => sum + (i.amount || 0),
    0
  );

  setFormData(prev => ({
    ...prev,
    totalAmount: subtotal,
    grandTotal: Math.round(
      subtotal + Number(prev.extraCharges || 0)
    )
  }));
}, [formData.items, formData.extraCharges]);


const getTierPrice = (tiers, qty) => {
  let price = Number(tiers?.[0]?.price || 0);

  tiers.forEach(t => {
    if (qty >= Number(t.qty)) {
      price = Number(t.price);
    }
  });

  return price;
};


const handleItemChange = (index, product) => {
  const updated = [...formData.items];

  const tiers = JSON.parse(product.sell_price || "[]");

  const qty = 1;
  const price = getTierPrice(tiers, qty);

  updated[index] = {
    itemId: product.id,
    name: product.name,
    mrp: Number(product.mrp || 0),
    sell_price: tiers,
    quantity: qty,
    price,
    amount: price * qty
  };

  updateTotals(updated);
};

const addProductFromBarcode = (product) => {
  const tiers = JSON.parse(product.sell_price || "[]");
  const qty = 1;
  const price = getTierPrice(tiers, qty);

  const newItem = {
    itemId: product.id,
    name: product.name,
    mrp: Number(product.mrp || 0),
    sell_price: tiers,
    quantity: qty,
    price,
    amount: price * qty
  };

  // setFormData(prev => ({
  //   ...prev,
  //   items: [...prev.items, newItem]
  // }));
    setFormData(prev => {
    lastAddedRowRef.current = prev.items.length;

    return {
      ...prev,
      items: [...prev.items, newItem]
    };
     });
};


useEffect(() => {
  if (lastAddedRowRef.current !== null) {
    const row = inputRefs.current[lastAddedRowRef.current];

    row?.qty?.focus(); 
    row?.qty?.select?.();

    lastAddedRowRef.current = null;
  }
}, [formData.items]);

const handleQtyChange = (index, value) => {
  const updated = [...formData.items];
  const qty = Number(value || 0);

  const item = updated[index];

  let price = item.price;

  if (!item.customPrice) {
    const tiers = item.sell_price || [];
    price = getTierPrice(tiers, qty);
  }

  updated[index].quantity = qty;
  updated[index].price = price;
  updated[index].amount = price * qty;

  updateTotals(updated);
};

const updateTotals = (updatedItems) => {
  const subtotal = updatedItems.reduce(
    (sum, i) => sum + (i.amount || 0),
    0
  );

  const grandTotal = Math.round(
    subtotal + Number(formData.extraCharges || 0)
  );

  setFormData(prev => ({
    ...prev,
    items: updatedItems,
    totalAmount: subtotal,
    grandTotal
  }));
};

  // ---------------- ADD / REMOVE ROW ----------------
  const addRow = () => {
    setFormData(prev => ({
      ...prev,
      items: [
        ...prev.items,
      {
         itemId: '',
        name: '',
        mrp: 0,
        sell_price: 0,
        quantity: 1,
        price: 0,
        amount: 0,
          customPrice: false
      }
    
      ]
    }));
  };

  const removeRow = (index) => {
    const updated = formData.items.filter((_, i) => i !== index);
    updateTotals(updated);
  };

  // ---------------- OPTIONS FOR SELECT ----------------
  const productOptions = items.map(p => ({
    value: p,
    label: `${p.name} (${p.brand})`
  }));

  const partyOptions = parties.map(p => ({
  value: p.id,
  label:  `${p.name} - ${p.mobile}`
}));


const handleSaveAndPrint = async () => {
  try {

    if (!formData.partyId) {
          setResponse({ message: 'Please select a party', status: 'error' });
    setTimeout(() => setResponse(''), 2000);
      return;
    }

    if (!formData.date) {
          setResponse({ message: 'Choose invoice date', status: 'error' });
    setTimeout(() => setResponse(''), 2000);
      return;
    }

    if (!formData.paymentMethod) {
          setResponse({ message: 'Select payment method', status: 'error' });
    setTimeout(() => setResponse(''), 2000);

      return;
    }

    if (
      formData.items.length === 0 ||
      formData.items.some(i => !i.itemId)
    ) {
    setResponse({ message: 'Add Items to save Bill', status: 'error' });
    setTimeout(() => setResponse(''), 2000);
      return;
    }

    setLoading(true);

   
const payload = {
  ...formData,
  items: formData.items.map(item => ({
    id: item.itemId,
    name: item.name,
    mrp: item.mrp,
    quantity: item.quantity,
    price: item.price,
    amount: item.amount,
    sell_price: item.sell_price
  }))
};


    const response = await fetch(
      "https://api.siddhabhairabistore.com/add-sale-bill",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || "Failed to create Bill");
    }

        setResponse({ message: 'Sale Bill created.', status: 'success' });
setSavedBill(result.bill);
setFormData({
    partyId: '',
    paymentMethod: '',
    amountPaid: '',
    remark: '',
      extraCharges: 0,
    totalAmount: 0,
     grandTotal: 0,
    items: [
      // {
        // itemId: '',
        // name: '',
        // mrp: 0,
        // sell_price: 0,
        // quantity: 1,
        // price: 0,
        // amount: 0,
        //   customPrice: false
      // }
    ]
  });
        setShowDetail(true);
        
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
    setTimeout(() => setResponse(''), 2000);
  }
};

useEffect(() => {
  document.getElementById("barcodeInput")?.focus();
}, []);


  return (
    <>
    <section className="my-4">
      <div className="px-4">
        <p className="page-title">Add Sale</p>

<div className='text-end'>
  <button className='edit-btn px-3 py-1' onClick={() => setShowAddParty(true)}>Add Party</button>&nbsp;&nbsp;
          <button className='edit-btn px-3 py-1' onClick={() => setShowAddItem(true)}>+ New Item</button></div>

<div className="row mt-2">

  {/* DATE */}
            <div className="col-md-6 col-sm-6 col-12">
              <label className="profile-label">Date</label><br />
    <input
      type="date"
      className="product-control col-md-6 col-12"
      value={formData.date}
      onChange={(e) =>
        setFormData({ ...formData, date: e.target.value })
      }
      required
    />
  </div>

            <div className="col-md-6 col-sm-6 col-12 text-md-end text-start">
              <label className="profile-label col-md-6 text-start">Party</label><br />


  <Select
    options={partyOptions}
    // value={partyOptions.find(
    //   p => p.value === formData.partyId
    // )}
    // onChange={(selected) =>
    //   setFormData(prev => ({
    //     ...prev,
    //     partyId: selected?.value || ''
    //   }))
    // }
value={
    formData.partyId
      ? partyOptions.find(p => p.value === formData.partyId)
      : null
  }
  onChange={(selected) =>
    setFormData(prev => ({
      ...prev,
      partyId: selected?.value || ''
    }))
  }

    placeholder="Search Party..."
    className="col-md-6 ms-auto text-start"
    required
  />

        </div>

</div>
{/* top row ends */}
         <div className="col-md-6 col-sm-6 col-12">
<input
  id="barcodeInput"
  type="text"
  placeholder="Scan Barcode..."
  className="col-md-6 product-control mt-2"
  value={barcodeQuery}
  onChange={(e) => setBarcodeQuery(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      fetchProductByBarcode(barcodeQuery.trim());
      setBarcodeQuery('');
    }
  }}
/>
  <button className="edit-btn ms-3" onClick={addRow}>
          + Add Item
        </button>

</div>


        {/* ITEMS TABLE HEADER */}
<div className='bg-white p-3 my-3 rounded-3'>

        <div className="row fw-bold mt-4">
          <div className="col-md-4">Item</div>
          <div className="col-md-2">MRP</div>
          <div className="col-md-2">Price/ Unit</div>
          <div className="col-md-1">Qty</div>
          <div className="col-md-2">Amount</div>
          <div className="col-md-1"></div>
        </div>



        {/* ROWS */}
        {formData.items.map((row, index) => (
          <div className="row align-items-center my-2" key={index}>
            
            {/* PRODUCT SELECT */}
            <div className="col-md-4">

              <Select
                options={productOptions}
                 value={
    row.itemId
      ? {
          value: {
            id: row.itemId,
            name: row.name
          },
          label: row.name
        }
      : null
  }
                onInputChange={(val) => setProductSearch(val)}
                onChange={(opt) => handleItemChange(index, opt?.value)}
                placeholder="Search item..."
              />
                           {row.name && (
    <small
      style={{
        display: "block",
        fontSize: '0.7em',
        marginTop: "2px",
        userSelect: "text"
      }}
    >
      {row.name}
    </small>
  )}
            </div>

         
            {/* PRICE */}
            <div className="col-md-2">
              <input
              // type='text'
               ref={(el) => {
    if (!inputRefs.current[index]) inputRefs.current[index] = {};
    inputRefs.current[index].mrp = el;
  }}
                className="product-control"
                style={{padding: '0.38em'}}
                value={row.mrp}
                  onKeyDown={(e) => handleKey(e, index, "mrp")}
                // readOnly
  onChange={(e) => {
    const updated = [...formData.items];
    updated[index].mrp = e.target.value || '';

    setFormData(prev => ({
      ...prev,
      items: updated
    }));
  }}              />
            </div>


            {/* PRICE */}
            <div className="col-md-2">
              <input
                className="product-control"
                // type='number'
                style={{padding: '0.38em'}}
                value={row.price}
                  ref={(el) => {
    if (!inputRefs.current[index]) inputRefs.current[index] = {};
    inputRefs.current[index].price = el;
  }}
  onKeyDown={(e) => handleKey(e, index, "price")}

  onChange={(e) => {
    const updated = [...formData.items];

    const newPrice = e.target.value ||'';

updated[index].customPrice = true;
    updated[index].price = newPrice;
      updated[index].sell_price = [
    {
      qty: updated[index].quantity,
      price: newPrice
    }
  ];


    updated[index].amount =
      newPrice * updated[index].quantity;

    updateTotals(updated);
  }}              />
            </div>


               {/* QTY */}
            <div className="col-md-1">
              <input
                value={row.quantity}
                // type='text'
                className="product-control"
                style={{padding: '0.38em'}}
                  ref={(el) => {
    if (!inputRefs.current[index]) inputRefs.current[index] = {};
    inputRefs.current[index].qty = el;
  }}
                onChange={(e) =>
                  handleQtyChange(index, e.target.value)
                }
                  onKeyDown={(e) => handleKey(e, index, "qty")}
              />
            </div>

            <div className="col-md-2">
              <input
                className="product-control"
                style={{padding: '0.38em'}}
                value={row.amount.toFixed(2)}
disabled
              />
            </div>

            {/* REMOVE */}
            <div className="col-md-1">
              <button
                className="close-btn"
                onClick={() => removeRow(index)}
              >
                X
              </button>
            </div>
          </div>
        ))}

        {/* ADD ROW */}
        <button className="edit-btn mt-3" onClick={addRow}>
          + Add Item
        </button>

        <hr />
          <p className='text-end fw-semibold'>Sub Total: ₹{(formData.totalAmount).toFixed(2)}</p>
</div>

<div className='row'>
  {/* PAYMENT METHOD */}
 <div className="col-md-6 col-sm-6 col-12 my-2">
                  <label className="profile-label">Payment Method</label><br />
    <select
      className="product-control col-md-6 col-12"
      value={formData.paymentMethod}
      required
      onChange={(e) =>
        setFormData({ ...formData, paymentMethod: e.target.value })
      }
    >
      <option value="">Select</option>
      <option value="Cash">Cash</option>
      <option value="UPI">UPI</option>
      <option value="Card">Card</option>
      <option value="Credit">Credit</option>
    </select>
  </div>

 <div className="col-md-6 col-sm-6 col-12 text-md-end text-start my-2">
                  <label className="profile-label col-md-6 text-start">Grand Total</label><br />
    <input
      type="number"
      className="product-control col-md-6 col-12"
      value={formData.grandTotal}
      disabled
    //   onChange={(e) =>
    //     setFormData({ ...formData, grandTotal: Number(e.target.value) })
    //   }
    />
  </div>


  {/* EXTRA CHARGES */}
 <div className="col-md-6 col-sm-6 col-12 my-2">
                  <label className="profile-label">Extra Charges</label><br />
    <input
      className="product-control col-md-6"
      value={formData.extraCharges}
      onChange={(e) =>
        setFormData({ ...formData, extraCharges: Number(e.target.value) })
      }
    />
  </div>

 <div className="col-md-6 col-sm-6 col-12 text-md-end text-start my-2">
                  <label className="profile-label col-md-6 text-start">Amount Received</label><br />
    <input
    //   type="number"
      className="product-control col-md-6 col-12"
      value={formData.amountPaid}
      onChange={(e) =>
        setFormData({ ...formData, amountPaid: Number(e.target.value) })
      }
    />
  </div>


 <div className="col-md-6 col-sm-6 col-12 my-2">
                  <label className="profile-label col-md-6 text-start">Remark</label><br />
    <textarea
      type="text"
      className="product-control col-md-6 col-12"
      value={formData.remark}
      onChange={(e) =>
        setFormData({ ...formData, remark: e.target.value })
      }
    />
  </div>


 <div className="col-md-6 col-sm-6 col-12 text-md-end text-start my-2">
                  <label className="profile-label col-md-6 text-start text-danger fw-bold">Due: ₹{(formData.grandTotal || 0) - (formData.amountPaid || 0)}</label>
    
    <div className="text-end mt-2">
  <button
    className="edit-btn"
    onClick={handleSaveAndPrint}
  >
    Save Bill
  </button>
</div>
  </div>



  </div>


      </div>
    </section>
          {loading && <Loading setLoading={setLoading} />}

{showAddItem &&
(
  <>
                <section className='detail-dialog px-4 py-4 overflow-y-auto'>
                    <div className='detail-dialog-inner col-md-10 animate__animated animate__zoomIn rounded mx-auto px-3 py-3' onClick={(e) => e.stopPropagation()}>
                      <button className='float-end close-btn' onClick={() => setShowAddItem(false)}>Close</button>
<AddProduct setResponse={setResponse} />
</div></section>
</>
)}


{showAddParty &&
(
  <>
                <section className='detail-dialog px-4 py-4 overflow-y-auto'>
                    <div className='detail-dialog-inner col-md-10 animate__animated animate__zoomIn rounded mx-auto px-3 py-3' onClick={(e) => e.stopPropagation()}>
                      <button className='float-end close-btn' onClick={() => setShowAddParty(false)}>Close</button>
<AddParty setResponse={setResponse} isModal={true} setShowAddParty={setShowAddParty}  onSuccess={fetchParty} />
</div></section>
</>
)}


{showDetail && 
<SaleOrderInvoice
setShowDetail={setShowDetail} selectedOrder={savedBill} userData={userData} />
}

          </>
  );
};

export default AddSale;